import { Stack, Typography } from '@mui/material'
import React from 'react'

import { getBlastRadiusValue } from 'components/scenarios/concurrent/attack-attributes'

import type { InfraAttackNode } from 'types/api/scenarios/scenario'

export const AttackGraphNodeBlastRadius: React.FC<{
  node: InfraAttackNode
}> = ({ node }) => {
  return (
    <Stack>
      <Typography
        sx={{
          fontWeight: 'bold'
        }}
      >
        {getBlastRadiusValue(node)}
      </Typography>
      <Typography variant="secondaryCaption">of selected targets</Typography>
    </Stack>
  )
}
